module.exports = __webpack_public_path__ + "img/008-grid.683873dd.svg";